import { ParsingCarStatisticsCards } from './ParsingCarStatisticsCard';

export default ParsingCarStatisticsCards;